module.exports = __webpack_public_path__ + "static/world-3e61fdd8d8e6096c6eb61cbb990d1311.svg";